<template>
	<div class="scroll-wrapper" :class="[direction]" ref="scrollWrapper">
		<div class="scroll-content">
			<slot></slot>
		</div>
	</div>
</template>

<script>
import BScroll from 'better-scroll';

export default {
	props: {
		// 滚动方向：'horizontal' 或 'vertical'
		direction: {
			type: String,
			default: 'vertical', // 默认纵向滚动
			validator: value => ['horizontal', 'vertical'].includes(value)
		},
		// 是否开启点击事件
		click: {
			type: Boolean,
			default: true
		},
		// 滚动监听类型（0: 不监听，1: 滚动结束时触发，2: 实时触发）
		probeType: {
			type: Number,
			default: 3
		}
	},
	data() {
		return {
			scroll: null
		};
	},
	mounted() {
		this.$nextTick(() => {
			this.initScroll();
		});
	},
	methods: {
		initScroll() {
			if (!this.$refs.scrollWrapper) return;

			const scrollX = this.direction === 'horizontal';
			const scrollY = this.direction === 'vertical';

			this.scroll = new BScroll(this.$refs.scrollWrapper, {
				scrollX,
				scrollY,
				click: this.click,
				probeType: this.probeType,
				mouseWheel: true // Better-Scroll 将接管滚轮事件，从而阻止了原生的滚动行为（滚动条）
			});

			if (this.probeType > 0) {
				this.scroll.on('scroll', pos => {
					this.$emit('scroll', pos);
				});
			}
		},
		// 刷新滚动区域
		refresh() {
			this.scroll && this.scroll.refresh();
		},
		// 滚动到指定位置
		scrollTo(x, y, duration = 500) {
			this.scroll && this.scroll.scrollTo(x, y, duration);
		}
	},
	beforeDestroy() {
		if (this.scroll) {
			this.scroll.destroy();
		}
	}
};
</script>

<style lang="less" scoped>
.scroll-wrapper {
	width: 100%;
	overflow: hidden;

	&.horizontal {
		white-space: nowrap;

		.scroll-content {
			min-height: 100%;
			display: inline-flex;
			flex-wrap: nowrap;
		}
	}
	&.vertical {
		height: 100%;

		.scroll-content {
			min-height: 100%;
		}
	}
}
</style>
